// extracted by mini-css-extract-plugin
export default {"order_table":"AvailablePromotionsList_order_table__OvvnG","header_section":"AvailablePromotionsList_header_section__LIK-P","lists_":"AvailablePromotionsList_lists___kJkQ2"};